import { useEffect, useState } from "react";
import { useApp } from "@/contexts/AppContext";
import WelcomePage from "./WelcomePage";
import LoginPage from "./LoginPage";
import SurveyPage from "./SurveyPage";
import HomePage from "./HomePage";
import SplashScreen from "@/components/SplashScreen";

const Index = () => {
  const { user, isAuthenticated, hasSeenWelcome, hasSurveyed, loading } = useApp();
  const [showSplash, setShowSplash] = useState(() => {
    if (sessionStorage.getItem("splash_shown") === "1") return false;
    return true;
  });

  // Guest users skip survey — they're auto-onboarded.
  const isGuest = user?.isAnonymous === true;
  const guestReady = isGuest;

  const isScrollablePage = !hasSeenWelcome || !isAuthenticated ||
    (!guestReady && !hasSurveyed);

  useEffect(() => {
    if (isScrollablePage) {
      document.body.classList.remove("app-locked");
    } else {
      document.body.classList.add("app-locked");
    }
    return () => {
      document.body.classList.add("app-locked");
    };
  }, [isScrollablePage]);

  if (showSplash) {
    return (
      <SplashScreen onFinished={() => {
        sessionStorage.setItem("splash_shown", "1");
        setShowSplash(false);
      }} />
    );
  }

  if (loading) {
    // Render an empty themed shell while auth resolves — no spinner flash, no
    // black gap. The background matches the rest of the app.
    return <div className="min-h-screen bg-background" />;
  }

  if (!hasSeenWelcome) return <WelcomePage />;
  if (!isAuthenticated) return <LoginPage />;
  if (guestReady) return <HomePage />;
  if (!hasSurveyed) return <SurveyPage />;
  return <HomePage />;
};

export default Index;
